import React from 'react';
import { Card } from './ui/Card';

interface School {
  id: string;
  name: string;
  location: string;
  division: string;
  conference: string;
  type: 'Men' | 'Women' | 'Both';
  size: string;
  founded: string;
}

interface SchoolCardProps {
  school: School;
  onClick?: () => void;
}

export const SchoolCard: React.FC<SchoolCardProps> = ({ school, onClick }) => {
  const getTypeStyles = (type: string) => {
    switch (type) {
      case 'Both':
        return 'bg-rowing-blue bg-opacity-10 text-rowing-blue';
      case 'Men':
        return 'bg-rowing-navy bg-opacity-10 text-rowing-navy';
      case 'Women':
        return 'bg-rowing-red bg-opacity-10 text-rowing-red';
      default:
        return 'bg-gray-100 text-gray-600';
    }
  };

  return (
    <Card hover onClick={onClick}>
      <Card.Body>
        <div className="flex justify-between items-start mb-4">
          <h3 className="text-xl font-semibold text-rowing-navy">{school.name}</h3>
          <span className={`px-2 py-1 text-xs rounded-full ${getTypeStyles(school.type)}`}>
            {school.type}
          </span>
        </div>

        <div className="space-y-2 text-sm">
          {/* Location */}
          <div className="flex items-center text-rowing-gray-600">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
            {school.location}
          </div>

          {/* Division & Conference */}
          <div className="flex items-center text-rowing-gray-600">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
              />
            </svg>
            {school.division} • {school.conference}
          </div>

          {/* Program Info */}
          <div className="flex items-center text-rowing-gray-600">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
            {school.size} • Est. {school.founded}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};
